import ReactPixel from 'react-facebook-pixel';
import Environment from './Environment';
import Logger from './Logger';

const subscribe = (fBData) => {
  const { currency, value } = fBData;
  const subscribeData = {
    currency,
    value,
  };
  ReactPixel.track('Subscribe', subscribeData);
};

const populateFBData = (trackingData, cartInfo) => {
  const contentIds = [];
  const contentType = 'product';
  const contents = [];
  if (cartInfo.subscription && cartInfo.subscription.plan) {
    const subscriptionToAddData = {
      id: `${cartInfo.subscription.plan.title} Subscription`,
      category: 'Subscription',
      price:
        cartInfo.subscription.plan.costWithCoupon ||
        cartInfo.subscription.plan.actualCost,
      quantity: 1,
      sku: cartInfo.subscription.plan._id || '1234',
    };
    contentIds.push(`${cartInfo.subscription.plan.title} Subscription`);
    contents.push(subscriptionToAddData);
  }
  if (cartInfo.productsAndDetails && cartInfo.productsAndDetails.length) {
    cartInfo.productsAndDetails.forEach((productAndDetails) => {
      const productToAddData = {
        id: productAndDetails.product.name || 'Missing product name',
        category: 'Shop',
        price:
          productAndDetails.promoItem && productAndDetails.product.ownPromoData
            ? productAndDetails.product.ownPromoData.cost
            : productAndDetails.product.actualCost || 0,
        quantity: productAndDetails.quantity || 1,
        sku: productAndDetails.product.sku || 'Missing product SKU',
      };
      contentIds.push(productAndDetails.product.name);
      contents.push(productToAddData);
    });
  }
  let itemTotal = 0;
  if (cartInfo.subscription && cartInfo.subscription.plan) {
    itemTotal += 1;
  }
  if (cartInfo.productsAndDetails && cartInfo.productsAndDetails.length) {
    itemTotal += cartInfo.productsAndDetails.length;
  }
  const fBData = {
    currency: 'USD',
    value: trackingData.total,
    content_ids: contentIds, // eslint-disable-line camelcase
    content_type: contentType, // eslint-disable-line camelcase
    contents,
    num_items: itemTotal, // eslint-disable-line camelcase
  };

  return fBData;
};

function FBTransactionComplete(trackingData, cartInfo) {
  try {
    if (Environment.getEnv === 'PRODUCTION') {
      const fBData = populateFBData(trackingData, cartInfo);
      ReactPixel.fbq('track', 'Purchase', fBData, {
        eventID: trackingData.res.justPurchasedPurchaseId.toString(),
      });
      subscribe(fBData);
    }
  } catch (e) {
    Logger.error(e);
  }
}

const pageLoaded = () => {
  ReactPixel.pageView();
};

const checkoutStarted = (cart) => {
  const cartTotal = {
    total: cart.subCosts ? cart.subCosts.overallTotal : 0,
  };
  const fBData = populateFBData(cartTotal, cart);
  ReactPixel.track('InitiateCheckout', fBData);
};

const addToCart = (cart) => {
  const cartTotal = {
    total: cart.subCosts ? cart.subCosts.overallTotal : 0,
  };
  const fBData = populateFBData(cartTotal, cart);
  fBData.content_name = 'Add To Cart'; // eslint-disable-line camelcase
  ReactPixel.track('AddToCart', fBData);
};

const addLead = (leadData, category) => {
  const fbData =
    category === 'Breast Pump'
      ? {
          content_category: category, // eslint-disable-line camelcase
          content_name: leadData.matchedPartner || 'No matched partner', // eslint-disable-line camelcase
        }
      : {
          content_category: category, // eslint-disable-line camelcase
        };
  ReactPixel.track('Lead', fbData);
};

export default {
  FBTransactionComplete,
  pageLoaded,
  checkoutStarted,
  addToCart,
  subscribe,
  addLead,
};
